<template>
    <div class="container-tips w-full">
        <div class="flex flex-row py-4">
            <div class="w-1/2 text-2xl pb-4 px-2">
                <a href="https://www.facebook.com/StudioEmme" _target="blank">
                    <div
                        class="w-11 h-11 flex items-center justify-center p-8 pointer">
                        <i class="fa-brands fa-facebook"></i>
                    </div>
                </a>
            </div>
            <div class="w-1/2 text-2xl px-2">
                <a href="https://www.instagram.com/studioemmeofficial/" _target="blank"><div
                    class="w-11 h-11 flex items-center justify-center  p-8 pointer">
                    <i class="fa-brands fa-instagram"></i>
                </div>
                </a>
            </div>
            <div class="w-1/2 text-2xl px-2">
                <a href="https://www.tiktok.com/@studio.emme.official/" _target="blank"><div
                    class="w-11 h-11 flex items-center justify-center  p-8 pointer">
                    <i class="fa-brands fa-tiktok"></i>
                </div>
                </a>
            </div>
            <div class="w-1/2 text-2xl px-2">
                <a href="https://www.youtube.com/@StudioEmme2011" _target="blank">
                    <div
                        class="w-11 h-11 flex items-center justify-center p-8 pointer">
                        <i class="fa-brands fa-youtube"></i>
                    </div>
                </a>
            </div>
            <div class="w-1/2 text-2xl px-2">
                <a href="https://www.linkedin.com/company/studio-emme-agenzia" _target="blank">
                    <div
                        class="w-11 h-11  flex items-center justify-center p-8 pointer">
                        <i class="fa-brands fa-linkedin"></i>
                    </div>
                </a>
            </div>

        </div>
    </div>
</template>

<script>
export default {
    name: "tips",
    data() {
        return {
            icon: true
        }
    },
}
</script>

<style lang="scss" scoped>

</style>